<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex xs12 md12>
        <v-menu offset-y right>
          <template v-slot:activator="{ attrs, on }">
            <!-- <v-layout wrap justify-center v-bind="attrs" v-on="on" class="hidden-lg-and-up" >
              <v-flex xs12  align-self-center>
                <v-icon large>mdi-account-circle-outline</v-icon>
              </v-flex>
          </v-layout> -->
            <v-layout wrap justify-center v-bind="attrs" v-on="on"  class="hidden-md-and-down">
              <v-flex xs2  align-self-center>
                <!-- <v-icon large title="Account Info" size="20">
                  mdi-account-star
                </v-icon> -->
                <!-- <v-img src="../../src/assets/icons/settings.png"></v-img> -->
                <v-icon large color="grey">mdi-account-circle-outline</v-icon>
              </v-flex>
              <v-flex xs10 text-left pl-4>
               <v-layout wrap>
                <v-flex xs12 align-self-center>
                  <span style="font-family:RMedium;font:size:16px;color:black; ">
                  {{ userData.username }}
                  <!-- {{ userData.username.split(' ')[0] }} -->

                </span>
                  </v-flex>
                  <v-flex xs12 sm8 align-self-center v-if="userData.mainRole">
                    <!-- v-if="userData.mainRole.roles !='SuperAdmin'" -->
                <span  v-if="userData.mainRole.roles=='ConstituencyPresident'"
                  style="
                    font-family: RRegular;
                    font-size: 14px;
                    color: grey;
                  " class="text-truncate"
                >
                  President </span
                >
                <span  v-else
                  style="
                    font-family: RRegular;
                    font-size: 14px;
                    color: grey;
                  " class="text-truncate"
                >
                  {{ userData.mainRole.roles }}  </span
                >
                </v-flex>
               
               </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center v-bind="attrs" v-on="on"  class="hidden-lg-and-up">
              <v-flex xs12  align-self-center>
                <v-icon  color="grey">mdi-account-circle-outline</v-icon>
              </v-flex>
            </v-layout>
          </template>
          <v-card tile flat :elevation="0" max-width="250px">
            <v-layout wrap justify-center py-4 v-if="userData.mainRole">
              <v-flex pt-4 xs12>
                <span
                  style="
                    font-family: RBold;
                    font-size: 16px;
                    color: #000000;
                  " 
                >
                  Welcome<br />
                  {{ userData.username }} <br />
                </span>
                </v-flex>
              <v-flex pt-2 xs12>
                <v-icon  color="grey" size="30">
                  mdi-account-circle-outline
                </v-icon>
              </v-flex>
              <v-flex xs12 v-if="userData.mainRole=='SuperAdmin'">
                <router-link to="/profile">
                  <span
                    v-if="appLogin"
                    style="
                      font-family: poppinsmedium;
                      font-size: 13px;
                      color: #1e1b1b;
                    "
                  >
                    <!-- <span v-if="appUser.guest">
                      {{ appUser.guest.name }}
                    </span> -->
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 sm8 align-self-center v-if="userData.mainRole">
                <span  v-if="userData.mainRole.roles"
                  style="
                    font-family: RRegular;
                    font-size: 14px;
                    color: grey;
                  "  class="text-truncate"
                >
                 {{ userData.mainRole.roles }}</span
                > </v-flex>
              <v-flex xs12 sm8 align-self-center  v-if="userData.mainRole.roles =='ConstituencyPresident' || userData.mainRole.roles =='Aspirant'">
                <span  v-if="userData.assemblyConstituencyId"
                  style="
                    font-family: RRegular;
                    font-size: 14px;
                    color: grey;
                  "  class="text-truncate"
                >
                 {{ userData.assemblyConstituencyId.name }}</span
                >
                </v-flex>
              <v-flex xs12 pt-2 v-if="userData.mainRole.roles=='ConstituencyPresident' || userData.mainRole.roles=='Aspirant'">
                <v-btn
                  v-if="appLogin"
                  color="#0000001f"
                  outlined
                  tile
                  small
                  :ripple="false"
                  @click="$router.push('/userProfile')"
                >
                  <span
                    style="
                      font-family: RRegular;
                      font-size: 14px;
                      color: #182444;
                    "
                  >
                  Profile
                  </span>
                </v-btn>
              </v-flex>
              <v-flex xs12 pt-2>
                <v-btn
                  v-if="!appLogin"
                  color="#0000001f"
                  outlined
                  tile
                  small
                  :ripple="false"
                  to="/login"
                >
                  <span
                    style="
                      font-family: RRegular;
                      font-size: 14px;
                      color: #182444;
                    "
                  >
                    LOGIN
                  </span>
                </v-btn>
                <v-btn
                  v-if="appLogin"
                  color="#0000001f"
                  outlined
                  tile
                  small
                  :ripple="false"
                  @click="appLogout"
                >
                  <span
                    style="
                     font-family: RRegular;
                      font-size: 14px;
                      color: #182444;
                    "
                  >
                    LOGOUT
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import store from "./../store";
import axios from "axios";
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    userData() {
      return this.$store.state.userData;
    },
  },

  methods: {
    appLogout() {
      axios({
        method: "get",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status==true) {
            this.$store.commit("logoutUser", true);
            localStorage.removeItem("id");
            // store.commit("menu", response.data.menus);
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script> 
